import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { LOCALE_DISPLAY, SUPPORTED_LOCALES, SupportedLocale } from '@/i18n/index';
import { useLocale } from '@/contexts/LocaleContext';

export const LocaleSwitcher = () => {
  const { t } = useTranslation();
  let currentLocale: SupportedLocale = 'en-US';
  let setLocale: ((locale: SupportedLocale) => void) | null = null;

  try {
    const ctx = useLocale();
    currentLocale = ctx.currentLocale;
    setLocale = ctx.setLocale;
  } catch {
    // LocaleProvider not available, render static
  }

  if (!setLocale) return null;

  const handleSelect = setLocale;
  const display = LOCALE_DISPLAY[currentLocale];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-6 px-1.5 text-muted-foreground hover:text-foreground hover:bg-secondary text-xs gap-1"
        >
          <span className="font-medium">{display.shortCode}</span>
          <span className="sr-only">{t('common.switchLanguage')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {SUPPORTED_LOCALES.map((locale) => {
          const d = LOCALE_DISPLAY[locale];
          return (
            <DropdownMenuItem
              key={locale}
              onClick={() => handleSelect(locale)}
              className={`cursor-pointer ${
                currentLocale === locale ? 'bg-accent' : ''
              }`}
            >
              <span className="flex items-center gap-2 w-full">
                <span className="text-sm font-medium">
                  {d.language}
                </span>
                {currentLocale === locale && (
                  <span className="text-xs text-muted-foreground ml-auto">✓</span>
                )}
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LocaleSwitcher;
